import { Circle, Sparkles, Crown, Monitor, Smartphone, Square } from 'lucide-react'

/**
 * Hardcoded video models (no API fetch needed)
 */
export const VIDEO_MODELS = [
  { value: 'basic', label: 'Basic', description: '', icon: Circle, locked: false },
  { value: 'standard', label: 'Standard', description: '', icon: Sparkles, locked: true },
  { value: 'premium', label: 'Premium', description: 'With audio', icon: Crown, locked: true },
] as const

/**
 * Hardcoded durations by model
 */
export const DURATIONS: Record<VideoModel, readonly string[]> = {
  basic: ['3'],
  standard: ['3', '6'],
  premium: ['3', '6', '10'],
}

export type VideoModel = 'basic' | 'standard' | 'premium'

/**
 * Hardcoded aspect ratios
 */
export const ASPECT_RATIOS = [
  { value: 'horizontal', label: '16:9 Landscape', icon: Monitor },
  { value: 'vertical', label: '9:16 Portrait', icon: Smartphone },
  { value: 'square', label: '1:1 Square', icon: Square },
] as const

/**
 * Hardcoded templates for Instant Videos
 * These are placeholders - in production you'd have real video URLs
 */
export const TEMPLATES = [
  {
    id: '1',
    name: 'Dancing',
    thumbnail: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: false,
  },
  {
    id: '2',
    name: 'Singing',
    thumbnail: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: false,
  },
  {
    id: '3',
    name: 'Interview',
    thumbnail: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: false,
  },
  {
    id: '4',
    name: 'Presentation',
    thumbnail: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: true,
  },
  {
    id: '5',
    name: 'Workout',
    thumbnail: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: true,
  },
  {
    id: '6',
    name: 'Cooking',
    thumbnail: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=400&fit=crop',
    videoUrl: '',
    isPremium: true,
  },
] as const

export type AspectRatio = typeof ASPECT_RATIOS[number]['value']
export type Template = typeof TEMPLATES[number]
